module.exports = __webpack_public_path__ + "static/media/pointantapplogo.cd16ae94.png";